/**
 * @param HTMLElementToSpy, element to spy on
 * @param navigationHeight, height of the navigation element
 * @instance scrollSpyElement = {
 * 	  title: current.querySelector('.hidden-title').innerText,
 *	  inpoint: scrolldown reference point for showing the instance
 *	  outpoint: scrollUp reference point for hiding the instance and showing the instance before
 *	  shown : boolean for current show state
 * }
 */
 class scrollSpyElement {
	constructor(HTMLElementToSpy, navigationHeight) {
		this.title    = HTMLElementToSpy.querySelector('.section_title_for_scrollspy h2').innerText;
		this.domNode  = HTMLElementToSpy;
		this.shown    = false;

		this.setInAndOutpoint(navigationHeight);
	}
	
	setInAndOutpoint(navigationHeight = 0) {
		const SpaceToTop      = this.domNode.offsetTop - navigationHeight;

		this.inpoint  = SpaceToTop + this.domNode.querySelector('.section_title_for_scrollspy').offsetHeight;
		this.outpoint = SpaceToTop;
	}
}